import React from "react";
import styled from "styled-components";

//Import Image
import home1 from "../img/home2.jpg";

//Import icons
import clock from "../img/icon/ai.svg";
import teamwork from "../img/icon/innovation.svg";
import money from "../img/icon/tech-support.svg";
import diaphragm from "../img/icon/tech.svg";

//Styles

import { About, Description, Image } from "../Styles";

const ServicesSection = () => {
  return (
    <Services>
      <Description>
        <h2>
          High <span>quality</span> services
        </h2>
        <Cards>
          <Card>
            <div className="icon">
              <img alt="icon" src={clock} />
              <h3>Efficient</h3>
            </div>
            <p>Lorem ipsum dolor sit amet.</p>
          </Card>
          <Card>
            <div className="icon">
              <img alt="icon" src={teamwork} />
              <h3>Teamwork</h3>
            </div>
            <p>Lorem ipsum dolor sit amet.</p>
          </Card>
          <Card>
            <div className="icon">
              <img alt="icon" src={diaphragm} />
              <h3>Diaphragm</h3>
            </div>
            <p>Lorem ipsum dolor sit amet.</p>
          </Card>
          <Card>
            <div className="icon">
              <img alt="icon" src={money} />
              <h3>Affordable</h3>
            </div>
            <p>Lorem ipsum dolor sit amet.</p>
          </Card>
        </Cards>
      </Description>
      <Image>
        <img alt="camera" src={home1} />
      </Image>
    </Services>
  );
};

const Services = styled(About)`
  h2 {
    padding-bottom: 5rem;
  }
  p {
    width: 70%;
    padding: 2rem 0rem 4rem 0rem;
  }

  .icon img {
    height: 30px;
    width: auto;
  }
`;
const Cards = styled.div`
  display: flex;
  flex-wrap: wrap;
  @media (max-width: 700px) {
    justify-content: center;
  }
`;
const Card = styled.div`
  flex-basis: 10rem;
  margin-right: 3rem;

  .icon {
    display: flex;
    align-items: center;
    background: #202020;
    color: black;
    padding: 0.5rem;
    h3 {
      margin-left: 1rem;
      color: white;
    }
  }
  p {
    font-size: 17px;
  }

  @media (max-width: 700px) {
    margin-right: 1rem;
  }
`;

export default ServicesSection;
